module.exports = __webpack_public_path__ + "img/pen-clip-slash.59da7d42.svg";